var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", staticStyle: { background: "#f4f5f7" } },
    [
      _c(
        "BjSteps",
        {
          attrs: {
            active: "3",
            title: _vm.$t("route.BusinessrateCalculator"),
            defaultOptions: [
              _vm.$t("rateCalculator.ConsignmentDetails"),
              _vm.$t("toolsProfit.calculate"),
              _vm.$t("billingPage.Download"),
            ],
          },
        },
        [
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "main-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.returns },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini", model: _vm.queryParams, rules: _vm.rules },
        },
        [
          _c(
            "div",
            { staticClass: "newClsbox" },
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("rateCalculator.TransitDetails"))),
              ]),
              _c(
                "el-row",
                { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.CustomerName"),
                            prop: "totalPalletQty",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: { disabled: "", clearable: "" },
                            model: {
                              value: _vm.queryParams.customName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "customName", $$v)
                              },
                              expression: "queryParams.customName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("rateCalculator.table.profitmargin"),
                            prop: "standardPallet",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: { disabled: "", clearable: "" },
                            model: {
                              value: _vm.queryParams.profitMargin,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "profitMargin", $$v)
                              },
                              expression: "queryParams.profitMargin",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "rateCalculator.table.ShippingAddress"
                            ),
                            prop: "fromAddress",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: { disabled: "", clearable: "" },
                            model: {
                              value: _vm.queryParams.fromAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "fromAddress", $$v)
                              },
                              expression: "queryParams.fromAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "newClsbox",
              staticStyle: { "margin-top": "10px", "padding-bottom": "10px" },
            },
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("rateCalculator.ConsignmentDetails"))),
              ]),
              _c(
                "el-row",
                { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableData,
                            border: "",
                            script: "",
                            "max-height": "500px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.NO"),
                              type: "index",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("BjDialogListConfig.orderNo"),
                              prop: "orderNumber",
                              align: "center",
                              width: "80",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.deliveryAddress"
                              ),
                              prop: "deliveryAddress",
                              align: "center",
                              width: "125",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Country"),
                              prop: "toCountry",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.State"),
                              prop: "toState",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Postcode"),
                              prop: "toPostcode",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Suburb"),
                              prop: "toSuburb",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.SKUs"),
                              prop: "skus",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Weight"),
                              prop: "weight",
                              align: "center",
                              width: "125",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Length"),
                              prop: "length",
                              align: "center",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.width"),
                              prop: "width",
                              align: "center",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Height"),
                              prop: "height",
                              align: "center",
                              width: "110",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Qty"),
                              prop: "qty",
                              align: "center",
                              width: "110",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Volume"),
                              prop: "volume",
                              align: "center",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.PiceFromCustomer"
                              ),
                              prop: "customerPrice",
                              align: "center",
                              width: "145",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "newClsbox",
              staticStyle: { "margin-top": "10px", "padding-bottom": "10px" },
            },
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("rateCalculator.LogisticsService"))),
              ]),
              _c(
                "el-row",
                { staticStyle: { padding: "0 10px" }, attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableData1,
                            border: "",
                            script: "",
                            "max-height": "500px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.NO"),
                              type: "index",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "rateCalculator.tables.inquiryList"
                                ),
                                align: "center",
                              },
                            },
                            [[_vm._v("Best Courier Service Price")]],
                            2
                          ),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                "" +
                                _vm.$t("rateCalculator.tables.totalCost") +
                                _vm.$t("rateCalculator.tables.exclGST"),
                              prop: "totalCost",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                "" +
                                _vm.$t("rateCalculator.tables.totalQuote") +
                                _vm.$t("rateCalculator.tables.exclGST"),
                              prop: "totalQuote",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.profitMargin"
                              ),
                              prop: "profitMargin",
                              align: "center",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.totalCustomPrice"
                              ),
                              prop: "totalCustomPrice",
                              align: "center",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.totalDiff"),
                              prop: "totalDiff",
                              align: "center",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.totalPercentage"
                              ),
                              prop: "totalPercentage",
                              align: "center",
                              width: "180",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            "margin-top": "10px",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Note: margin =[Quote -Cost] / Quote; Difference Percentage=[Quote - Total Price From customer) / Total price From Customer]"
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "newClsbox",
              staticStyle: { "margin-top": "10px", "padding-bottom": "10px" },
            },
            [
              _c(
                "BjDivider",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.onDown },
                            },
                            [_vm._v(_vm._s(_vm.$t("billingPage.Download")))]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_vm._v(_vm._s(_vm.$t("rateCalculator.DownloadPreview")) + " ")]
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "0 10px" }, attrs: { gutter: 18 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableData2,
                            border: "",
                            script: "",
                            "max-height": "500px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.NO"),
                              type: "index",
                              width: "48",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("BjDialogListConfig.orderNo"),
                              prop: "orderNumber",
                              align: "center",
                              width: "94",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.deliveryAddress"
                              ),
                              prop: "deliveryAddress",
                              width: "120",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Country"),
                              prop: "toCountry",
                              align: "center",
                              width: "90",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.State"),
                              prop: "toState",
                              align: "center",
                              width: "95",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Postcode"),
                              prop: "toPostcode",
                              align: "center",
                              width: "115",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Suburb"),
                              prop: "toSuburb",
                              align: "center",
                              width: "82",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.SKUs"),
                              prop: "skus",
                              align: "center",
                              width: "98",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Weight"),
                              prop: "weight",
                              align: "center",
                              width: "116",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Length"),
                              prop: "length",
                              align: "center",
                              width: "94",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.width"),
                              prop: "width",
                              align: "center",
                              width: "95",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Height"),
                              prop: "height",
                              align: "center",
                              width: "95",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Qty"),
                              prop: "qty",
                              align: "center",
                              width: "63",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.Volume"),
                              prop: "volume",
                              align: "center",
                              width: "138",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                "" +
                                _vm.$t("rateCalculator.tables.bestPrice") +
                                _vm.$t("rateCalculator.tables.exclGST"),
                              prop: "bestPrice",
                              align: "center",
                              width: "78",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("rateCalculator.tables.provider"),
                              prop: "provider",
                              align: "center",
                              width: "140",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.customerPrice"
                              ),
                              prop: "customerPrice",
                              align: "center",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.differPrice"
                              ),
                              prop: "differPrice",
                              align: "center",
                              width: "90",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "rateCalculator.tables.diffPercentage"
                              ),
                              prop: "diffPercentage",
                              align: "center",
                              width: "150",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            "margin-top": "10px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("rateCalculator.chargeonyour")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }